import Result from "../components/ui/result";
export default Result;